import React, { memo } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './index.module.scss';

function ModalConfirmarFechamento({
    mostrar,
    titulo,
    texto,
    carregando=false,
    clicouCancelar,
    textoCarregando,
    clicouConfirmar,
    textoBotaoCancelar,
    textoBotaoConfirmar,
    quantidadeItensAtual=null,
    totalRegistros=null,
    clicouCancelarFechamento=null
}) {
    // faz a verificação dessa forma, para não passar pelo erro de verificação de "falsy" ao realizar verificações com numeros
    const possuiTotalRegistros  = (totalRegistros !== null && totalRegistros !== undefined);
    const possuiQuantidadeItens = (quantidadeItensAtual !== null && quantidadeItensAtual !== undefined);

    return (
        <Modal 
            show={mostrar} 
            onExited={() => {}}
            onHide={() => {}}
            size={'sm'}
            backdropClassName={[styles.modalBackdrop, 'teste'].join(' ')}            
        >
            <Modal.Header className='border-0'>
                <Modal.Title className='fw-bold'>
                    {titulo}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-center">{texto}</p>
                {(carregando && possuiQuantidadeItens && possuiTotalRegistros) && 
                    <p className="text-center w-100">
                        {`${quantidadeItensAtual} de ${totalRegistros}`}
                    </p>
                }
            </Modal.Body>
            <Modal.Footer className='border-0 justify-content-between'>
                {!carregando && <Button
                    variant={'padrao'}
                    onClick={clicouCancelar}
                    disabled={carregando}
                >
                    <span>{textoBotaoCancelar || 'Cancelar'}</span>
                </Button>}
                <Button
                    onClick={clicouConfirmar}
                    variant='success'
                    disabled={carregando}
                >
                    {carregando ? 
                        <>
                            <FontAwesomeIcon className="icone" pulse icon={["fas", 'spinner']} />
                            <span>{textoCarregando || `Carregando`}</span>
                        </> : 
                        <span>{textoBotaoConfirmar || 'Confirmar'}</span>
                    }
                </Button>                    
                {(carregando && clicouCancelarFechamento) && <Button
                    onClick={clicouCancelarFechamento}
                    variant='danger'
                    className='w-100'
                >
                    <span>Cancelar fechamento!</span>
                </Button>}
            </Modal.Footer>
        </Modal>
    )
}

export default memo(ModalConfirmarFechamento);